<template>
  <div>
    <div class="lcList wow animate__animated animate__fadeIn">
      <div class="lc-item maria" v-for="item in list" :key="item.key">
        <div class="display_flex" style="flex-direction: column">
          <div class="lc-img" :style="{ backgroundColor: item.color }">
            <OssImg :src="item.imgPath" />
          </div>
          <div class="lc-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="btn">
      <span class="b-text" @click="navTo('/consult')">方案咨询</span>
      <el-icon><DArrowRight /></el-icon>
    </div>
  </div>
</template>

<script setup>
import { navTo } from "@/utils/util";
import { ref } from "vue";
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss" scoped>
.lcList {
  margin-top: 32px;
  width: 100%;
  display: flex;
  font-family: "PingFang SC";
  justify-content: space-between;
  .lc-item {
    box-sizing: border-box;
    padding: 16px;
    width: 32%;
    height: 208px;
    border-radius: 16px;
    background: #ffffff;
    position: relative;
    gap: 16px;
    .lc-img {
      left: 50%;
      transform: translateX(-50%);
      top: 16px;
      position: absolute;
      width: 80px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 80px;
      margin-bottom: 10px;
    }
    .lc-desc {
      margin-top: 100px;
      color: #424242;
      font-weight: 500;
      font-size: 14px;
    }
  }
}
.btn {
  margin: 40px auto;
  display: inline-block;
  width: 121px;
  height: 40px;
  border-radius: 8px;
  background: #32A89E;
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  .b-text {
    margin-right: 10px;
    transform: translateY(-2px);
  }
}
</style>
